<template>
    <main id="page">
        <the-title title="Access Denied"></the-title>
        <div class="shape-area flip cyan-inner white-outer"></div>
        <b-container>
            <b-row class="justify-content-center">
                <b-col class="text-center">
                    <h2 class="not-found-content-header">Oops!</h2>
                    <p class="not-found-content-text">You don't have access to this page!</p>
                </b-col>
            </b-row>
        </b-container>
        <div class="shape-area reversed cyan-inner purple-outer"></div>
    </main>
</template>

<script>
export default {

}
</script>